import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

export function AssemblyPage() {
  return (
    <div className="space-y-6">
      <div>
        <div className="flex items-center gap-2">
          <h1 className="text-3xl font-bold tracking-tight">Assembly</h1>
          <Badge variant="outline" className="bg-yellow-50 text-yellow-700 border-yellow-200">
            🟡 Demo Mode
          </Badge>
        </div>
        <p className="text-muted-foreground mt-2">
          Manage product assembly, kitting, and bill of materials (BOM) operations.
        </p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Content Coming Soon</CardTitle>
          <CardDescription>
            This page will provide tools for managing assembly operations and tracking component usage.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="text-sm text-muted-foreground">
            <p className="mb-2">Planned features:</p>
            <ul className="list-disc list-inside space-y-1">
              <li>Bill of Materials (BOM) management</li>
              <li>Assembly order creation and tracking</li>
              <li>Component availability checking</li>
              <li>Assembly cost calculation</li>
              <li>Work order management</li>
            </ul>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
